import { render, staticRenderFns } from "./ValidationStatus.vue?vue&type=template&id=23b67ffd"
import script from "./ValidationStatus.vue?vue&type=script&lang=js"
export * from "./ValidationStatus.vue?vue&type=script&lang=js"
import style0 from "./ValidationStatus.vue?vue&type=style&index=0&id=23b67ffd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports